/* c8 ignore start */
export default () => import(/* webpackIgnore: true */'./3rd-party/zip.js');
/* c8 ignore stop */
